import { render, staticRenderFns } from "./case_pay.vue?vue&type=template&id=37741498&scoped=true"
import script from "./case_pay.vue?vue&type=script&lang=js"
export * from "./case_pay.vue?vue&type=script&lang=js"
import style0 from "./case_pay.vue?vue&type=style&index=0&id=37741498&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37741498",
  null
  
)

export default component.exports